import React, { useState } from 'react';
import { Button } from './ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import { Calendar } from './ui/calendar';
import { Popover, PopoverContent, PopoverTrigger } from './ui/popover';
import { CalendarIcon, MapPin, Users, Plane } from 'lucide-react';
import { format } from 'date-fns';
import { destinations } from '../data/mock';

export const BookingForm = () => {
  const [destination, setDestination] = useState('');
  const [departureDate, setDepartureDate] = useState();
  const [returnDate, setReturnDate] = useState();
  const [guests, setGuests] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    // Mock booking submission
    alert('Thank you for your inquiry! Our luxury travel specialist will contact you within 2 hours.');
  };

  return (
    <div className="bg-white/95 backdrop-blur-sm border border-amber-400/20 rounded-2xl p-6 shadow-2xl">
      <form onSubmit={handleSubmit} className="space-y-4">
        <h3 className="text-navy font-serif text-xl mb-4 flex items-center gap-2">
          <Plane className="w-5 h-5 text-amber-400" />
          Plan Your Journey
        </h3>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          {/* Destination Selection */}
          <div className="space-y-2">
            <label className="text-sm font-medium text-navy flex items-center gap-1">
              <MapPin className="w-4 h-4" />
              Destination
            </label>
            <Select value={destination} onValueChange={setDestination}>
              <SelectTrigger className="border-sand focus:border-amber-400">
                <SelectValue placeholder="Select destination" />
              </SelectTrigger>
              <SelectContent>
                {destinations.map((dest) => (
                  <SelectItem key={dest.id} value={dest.name}>
                    {dest.name}, {dest.country}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>

          {/* Departure Date */}
          <div className="space-y-2">
            <label className="text-sm font-medium text-navy">Departure</label>
            <Popover>
              <PopoverTrigger asChild>
                <Button
                  variant="outline" 
                  className="w-full justify-start text-left border-sand focus:border-amber-400"
                >
                  <CalendarIcon className="mr-2 h-4 w-4" />
                  {departureDate ? format(departureDate, "MMM dd") : "Select date"}
                </Button>
              </PopoverTrigger>
              <PopoverContent className="w-auto p-0" align="start">
                <Calendar
                  mode="single"
                  selected={departureDate}
                  onSelect={setDepartureDate}
                  initialFocus
                />
              </PopoverContent>
            </Popover>
          </div>

          {/* Return Date */}
          <div className="space-y-2">
            <label className="text-sm font-medium text-navy">Return</label>
            <Popover>
              <PopoverTrigger asChild>
                <Button
                  variant="outline"
                  className="w-full justify-start text-left border-sand focus:border-amber-400"
                >
                  <CalendarIcon className="mr-2 h-4 w-4" />
                  {returnDate ? format(returnDate, "MMM dd") : "Select date"}
                </Button>
              </PopoverTrigger>
              <PopoverContent className="w-auto p-0" align="start">
                <Calendar
                  mode="single"
                  selected={returnDate}
                  onSelect={setReturnDate}
                  initialFocus
                />
              </PopoverContent>
            </Popover>
          </div>

          {/* Guests */}
          <div className="space-y-2">
            <label className="text-sm font-medium text-navy flex items-center gap-1">
              <Users className="w-4 h-4" />
              Guests
            </label>
            <Select value={guests} onValueChange={setGuests}>
              <SelectTrigger className="border-sand focus:border-amber-400">
                <SelectValue placeholder="Select guests" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="1">1 Guest</SelectItem>
                <SelectItem value="2">2 Guests</SelectItem>
                <SelectItem value="3-4">3-4 Guests</SelectItem>
                <SelectItem value="5-8">5-8 Guests</SelectItem>
                <SelectItem value="9+">9+ Guests</SelectItem>
              </SelectContent>
            </Select>
          </div>
        </div>

        <Button 
          type="submit"
          className="w-full bg-gradient-to-r from-amber-400 to-yellow-500 hover:from-yellow-500 hover:to-amber-400 text-navy font-semibold py-3 transition-all duration-300 transform hover:scale-105 shadow-lg"
        >
          Plan My Journey
        </Button>
      </form>
    </div>
  );
};